export const API_BASE_URL = 'https://api.moverse.biz';
export const ACCESS_TOKEN = 'accessToken';
export const CLIENT = 'client';
export const OAUTH2_REDIRECT_URI = 'https://sso.moverse.biz/oauth2/redirect'

export const GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL = API_BASE_URL + '/oauth2/authorize/facebook?redirect_uri=' + OAUTH2_REDIRECT_URI;
export const TWITTER_AUTH_URL = API_BASE_URL + '/auth/twitter?redirect_uri=' + OAUTH2_REDIRECT_URI;



// WEBPACK FOOTER //
// ./src/constants/index.js